{
  "name": "npm-check-updates",
  "version": "23.1.1",
  "author": "Tomas Junnonen <tomas1@gmail.com>",
  "license": "Apache-2.0",
  "contributors": [
    "Raine Revere (https://github.com/raineorshine)",
    "Imamuzzaki Abu Salam <imamuzzaki@gmail.com>"
  ],
  "description": "Find newer versions of dependencies than what your package.json allows",
  "keywords": [
    "dependencies",
    "npm",
    "package.json",
    "update",
    "upgrade",
    "versions"
  ],
  "engines": {
    "node": "^22.22.2 || ^24.15.0 || >=26.0.0",
    "npm": ">=10.0.0"
  },
  "type": "module",
  "bin": {
    "npm-check-updates": "build/cli.js",
    "ncu": "build/cli.js"
  },
  "exports": {
    ".": {
      "types": "./build/index.d.ts",
      "default": "./build/index.js"
    },
    "./package.json": "./package.json"
  },
  "scripts": {
    "build": "vite build",
    "build:options": "node scripts/build-options.ts",
    "build:changelog": "node scripts/build-changelog.ts",
    "build:analyze": "cross-env ANALYZER=true vite build",
    "lint": "cross-env FORCE_COLOR=1 npm-run-all --parallel --continue-on-error --aggregate-output lint:*",
    "lint:lockfile": "lockfile-lint",
    "lint:types": "tsc --noEmit",
    "lint:markdown": "markdownlint-cli2 \"**/*.md\" \"!**/node_modules/**/*.md\" \"!build/**/*.md\"",
    "lint:src": "eslint --cache --cache-location node_modules/.cache/.eslintcache",
    "prepare": "git config core.hooksPath .hooks || exit 0",
    "prepublishOnly": "npm run build",
    "prettier": "prettier . --check",
    "prettier:fix": "prettier . --write",
    "vitest": "vitest",
    "test": "npm run lint:types && npm run test:unit && npm run test:e2e",
    "test:bun": "vitest run --config vitest.config.bun.js",
    "test:unit": "vitest run",
    "test:e2e": "bash ./test/e2e.sh",
    "ncu": "node build/cli.js"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/raineorshine/npm-check-updates.git"
  },
  "homepage": "https://github.com/raineorshine/npm-check-updates",
  "bugs": {
    "url": "https://github.com/raineorshine/npm-check-updates/issues"
  },
  "overrides": {
    "typescript": "$typescript",
    "eslint": "$eslint",
    "eslint-config-standard": {
      "eslint-plugin-n": "$eslint-plugin-n",
      "eslint-plugin-promise": "$eslint-plugin-promise"
    }
  },
  "devDependencies": {
    "@eslint/compat": "^2.1.1",
    "@eslint/js": "^10.0.1",
    "@microsoft/api-extractor": "^7.59.4",
    "@streamparser/json": "^0.0.26",
    "@trivago/prettier-plugin-sort-imports": "^6.0.2",
    "@types/bun": "^1.4.2",
    "@types/hosted-git-info": "^3.0.5",
    "@types/ini": "^4.1.1",
    "@types/node": "^26.6.5",
    "@types/npm-registry-fetch": "^8.0.9",
    "@types/parse-github-url": "^1.0.3",
    "@types/picomatch": "^4.0.3",
    "@types/progress": "^2.0.7",
    "@types/semver": "^7.8.0",
    "@types/semver-utils": "^1.1.3",
    "@types/update-notifier": "^6.0.8",
    "@typescript-eslint/eslint-plugin": "^8.71.1",
    "@typescript-eslint/parser": "^8.71.1",
    "camelcase": "^9.0.0",
    "cli-table3": "^0.6.5",
    "commander": "^15.0.0",
    "cross-env": "^10.1.0",
    "eslint": "^10.12.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-config-raine": "^0.5.0",
    "eslint-config-standard": "^17.1.0",
    "eslint-import-resolver-typescript": "^4.4.5",
    "eslint-plugin-import-x": "^4.17.1",
    "eslint-plugin-jsdoc": "^65.2.4",
    "eslint-plugin-n": "^18.4.1",
    "eslint-plugin-promise": "^7.3.0",
    "fast-glob": "^3.3.3",
    "fast-memoize": "^2.5.2",
    "find-up": "^8.0.0",
    "globals": "^17.13.0",
    "hosted-git-info": "^10.1.1",
    "ini": "^7.0.0",
    "jsonc-parser": "^3.3.1",
    "lilconfig": "^3.1.3",
    "lockfile-lint": "^5.1.0",
    "markdown-it": "^15.0.2",
    "markdownlint-cli2": "^0.23.3",
    "npm-registry-fetch": "^20.0.1",
    "npm-run-all2": "^9.0.3",
    "p-map": "^7.1.0",
    "parse-github-url": "^1.0.4",
    "picomatch": "^4.0.7",
    "prettier": "^3.9.10",
    "progress": "^2.0.3",
    "prompts-ncu": "^3.0.4",
    "semver": "^7.8.5",
    "semver-utils": "^1.1.4",
    "spawn-please": "^4.0.0",
    "ts-json-schema-generator": "^2.9.0",
    "typescript": "^6.0.3",
    "unplugin-dts": "^1.1.2",
    "untildify": "^6.0.0",
    "update-notifier": "^7.3.1",
    "valibot": "^1.5.0",
    "verdaccio": "^6.10.5",
    "vite": "^8.3.4",
    "vite-bundle-analyzer": "^1.3.9",
    "vitest": "^5.0.3",
    "yaml": "^2.9.1",
    "yarn": "^1.22.22"
  },
  "files": [
    "build"
  ],
  "allowScripts": {
    "yarn@1.22.22": true,
    "unrs-resolver@1.12.2": true,
    "fsevents@2.3.3": true
  }
}
